<template>
  <div>
    <header class="header-gl">
      <a class="logo" href="http://www.geely.com/">
        <img src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/20190214logo2.png"/>
      </a>
      <ul class="glmenu">
        <li class="lookall">
          <a @click="toggleMenu('showCxzl')" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_01')">
            <span>车型总览</span>
            <i class="glfico-down"></i>
          </a>
          <div class="glmenu-content" :class="{'showCxzl': menuToggle.showCxzl}">
            <div class="glmenu-content-title">
              <span>车型总览</span>
              <i class="close" @click="toggleMenu('showCxzl')">×</i>
            </div>
            <div class="glmenu-content-body glmenu-content-body-pc">
              <div class="vehicle-models">
                <div class="advance-search-wrapper">
                  <p class="advance-search-title">
                    探索车型
                  </p>
                  <form class="form advance-search-form">
                    <div class="advance-search-form-content">
                      <div class="form-item" data-filter="price">
                        <label class="label-mobile">价格区间</label>
                        <label>价格（元）：</label>
                        <div class="form-field slidable-content acline">
                          <el-slider
                            @change="changePrice"
                            v-model="price"
                            range
                            :min="30000"
                            :step="1000"
                            :max="300000">
                          </el-slider>
                          <div class="search-price-group">
                            <input type="text" v-model="searchParam.beginPrice" @change="onSearch"/>-
                            <input type="text" v-model="searchParam.endPrice" @change="onSearch"/>
                          </div>
                        </div>
                      </div>
                      <div class="form-item slidable">
                        <label class="label-mobile">
                          <span>结构</span>
                          <i class="glfico-right"></i>
                        </label>
                        <label>结构：</label>
                        <div class="form-field slidable-content">
                          <div class="check-list">
                            <div class="checkbox check-all" style="margin-left:0;">
                              <label>
                                <input type="checkbox" v-model="structureCheck"  @click="checkedStructureAll">
                                <span>全部</span>
                              </label>
                            </div>
                            <div class="checkbox" style="margin-left:0;margin-top:5px;" v-for="item in attriStructureList" :key="item.id" v-if="attriStructureList && attriStructureList.length > 0">
                              <label>
                                <input type="checkbox" v-model="checkedStructureModel" :value="item" @change="onSearch"> <span>{{ item }}</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-item slidable">
                        <label class="label-mobile">
                          <span>车系</span>
                          <i class="glfico-right"></i>
                        </label>
                        <label>车系：</label>
                        <div class="form-field">
                          <div class="check-list">
                            <div class="checkbox check-all">
                              <label>
                                <input type="checkbox" v-model="groupCheck"  @click="checkedGroupAll">
                                <span>全部</span>
                              </label>
                            </div>
                            <div class="checkbox" v-for="item in groupList" :key="item.id" v-if="groupList && groupList.length > 0">
                              <label>
                                <input type="checkbox" v-model="checkedGroup" :value="item" @change="onSearch"> <span>{{ item }}</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="vehicle-model">
                  <ul class="carslist" style="height:300px;overflow-y:scroll;overflow-x:hidden;">
                    <li v-for="item in dataList" :key="item.id" v-if="dataList && dataList.length > 0">
                      <div class="car-title mobile-hide" style="cursor:pointer" @click="onJump(item)">{{ item.name }}</div>
                      <div class="car-desc" v-if="item.isPriceHide === 0">官方指导价：￥{{ item.showPrice !== null ? item.showPrice.toLocaleString() : 0 }}起</div>
                      <div class="car-desc" v-if="item.isPriceHide === 1">预售价：敬请期待</div>
                      <div class="car-img">
                        <img :src="item.listImg" style="cursor:pointer" @click="onJump(item)"/>
                      </div>

                      <div class="know-more">
                        <div class="info-blockleft">
                          <div class="car-title mobile-hide" style="cursor:pointer" @click="onJump(item)">{{ item.name }}</div>
                          <div class="car-desc" v-if="item.isPriceHide === 0">官方指导价：￥{{ item.showPrice !== null ? item.showPrice.toLocaleString() : 0 }}起</div>
                          <div class="car-desc" v-if="item.isPriceHide === 1">预售价：敬请期待</div>
                          <div class="car-img">
                            <img :src="item.listImg" style="cursor:pointer" @click="onJump(item)"/>
                          </div>
                        </div>
                        <div class="info-block">
                          <div class="info-lists">
                            <label>外形尺寸</label>
                            <span>{{ item.shape !== null ? item.shape : ' - '}}</span>
                          </div>
                          <div class="info-lists">
                            <label>发动机</label>
                            <span>{{ item.engine !== null ? item.engine : ' - '}}</span>
                          </div>
                          <div class="info-lists">
                            <label>轴距</label>
                            <span>{{ item.wheel !== null ? item.wheel : ' - ' }}</span>
                          </div>
                          <div class="info-lists">
                            <label>变速箱</label>
                            <span>{{ item.gearbox !== null ? item.gearbox : ' - ' }}</span>
                          </div>
                          <div class="info-lists">
                            <label>百公里耗油</label>
                            <span>{{ item.consumption !== null ? item.consumption : ' - ' }}</span>
                          </div>
                          <div class="info-more" @click="toggleMenu('showCxzl')">
                            <a class="toBook" href="javascript:" v-if="1 > 2"><i
                              class="glfico-shijian"></i><span>快速预约</span></a>
                            <router-link class="toDetail" :to="{ path: '/order', query: { productId: item.productId, path: 'Orderview' }}"><i
                              class="glfico-gantanhaozhong"></i><span>了解详情</span></router-link>
                          </div>
                        </div>
                        <span class="gou glfico-gouxuan"></span>
                      </div>
                    </li>
                  </ul>

                </div>
                <div class="info-input" v-if="1 > 2">
                  <form action="">
                    <label class="book-title">预约试驾</label>
                    <div class="info-form">
                      <div>
                        <label><span class="label-icon glfico-user"></span><span
                          class="label-text">姓名</span></label>
                        <input type="text">
                      </div>
                      <div>
                        <label><span class="label-icon glfico-shouji"></span><span
                          class="label-text">手机</span></label>
                        <input type="text">
                      </div>
                      <div>
                        <label><span class="label-icon glfico-cheliang-"></span></label>
                        <input type="text" value="帝豪GS">
                      </div>
                    </div>
                    <div class="book-btn">
                      <span class="glfico-clock"></span>
                      <span>快速预约</span>
                    </div>
                    <div class="book-mark">
                      <span class="glfico-gouxuan1"></span>
                      <span>预约成功！客服会尽快与您联系</span>
                    </div>
                  </form>
                  <!--<div class="book-remove">
                      <span class="close book-removebtn glfico-close1"></span>
                  </div>-->
                </div>

              </div>
            </div>
          </div>
        </li>
        <li class="buy-support">
          <a @click="toggleMenu('showPptd')" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_02')">
            <span>品牌天地</span>
            <i class="glfico-down"></i>
          </a>
          <div class="glmenu-content" :class="{'showPptd': menuToggle.showPptd}">
            <div class="glmenu-content-title">
              <span>品牌天地</span>
              <i class="close" @click="toggleMenu('showPptd')">×</i>
            </div>
            <div class="glmenu-content-body">
              <div class="content-left">
                <p class="menuTitle">品牌天地</p>
                <div class="support-menutitle">
                  <span class="support-text">进入品牌天地</span>
                </div>
              </div>
              <span class="line-vertical"></span>
              <ul>
                <li>
                  <a href="http://www.zgh.com" target="_blank">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/PinPaiTianDi/jtgs.png">
                      <img class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/头部导航切图/集团概述.jpg">
                    </div>
                    <span>集团概述</span>
                    <span class="glfico-right"></span>
                  </a>
                  <div class="support-items">
                    <a href="http://www.zgh.com/zh-hans/our-achievements" target="_blank">吉利大事记</a>
                  </div>

                </li>
                <li>
                  <a href="http://www.geely.com/geelynews/newslist" target="" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_04')">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/PinPaiTianDi/jljy.png">
                      <img class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/头部导航切图/新闻资讯.jpg">
                    </div>
                    <span>新闻资讯</span>
                    <span class="glfico-right"></span>
                  </a>
                  <div class="support-items">
                    <a href="http://www.geely.com/geelynews/newslist" target="_blank">新闻资讯</a>
                    <a href="http://www.geely.com/geelynews/newslist?newsDataValue=Video" target="_blank">视频集锦</a>
                  </div>

                </li>
                <li>
                  <a href="http://intec.geely.com" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_05')">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/PinPaiTianDi/jspp.png">
                      <img class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/头部导航切图/技术品牌.jpg">
                    </div>
                    <span>技术品牌</span>
                    <span class="glfico-right"></span>
                  </a>
                  <div class="support-items">
                    <a href="http://intec.geely.com/G-Power/" target="_blank">高效动力技术</a>
                    <a href="http://intec.geely.com/G-Safety/" target="_blank">人本安全技术</a>
                    <a href="http://intec.geely.com/G-Netlink/" target="_blank">智慧互联车行技术</a>
                    <a href="http://intec.geely.com/G-Blue/" target="_blank">健康生态技术</a>
                    <a href="http://intec.geely.com/G-Pilot/" target="_blank">智能驾驶技术</a>
                  </div>

                </li>
                <li>
                  <a href="http://www.geely.com/brandworld" target="">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/PinPaiTianDi/qywh.png">
                      <img class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/头部导航切图/品牌天地.png">
                    </div>
                    <span>品牌天地</span>
                    <span class="glfico-right"></span>
                  </a>
                  <div class="support-items">
                    <a href="http://www.geely.com/brandworld?id=brandworld#ToCulture" target="_blank">企业文化</a>
                    <a href="http://www.geely.com/brandworld?id=brandworld#ToEducation" target="_blank">吉利教育</a>
                    <a href="http://www.geely.com/brandworld#ToResponsibility" target="_blank">社会责任</a>
                  </div>

                </li>
              </ul>
            </div>
          </div>
        </li>
        <li class="buy-support">
          <a @click="toggleMenu('showGczc')" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_06')">
            <span>购车支持</span>
            <i class="glfico-down"></i>
          </a>
          <div class="glmenu-content" :class="{'showGczc': menuToggle.showGczc}">
            <div class="glmenu-content-title">
              <span>购车支持</span>
              <i class="close" @click="toggleMenu('showGczc')">×</i>
            </div>
            <div class="glmenu-content-body">
              <div class="content-left">
                <p class="menuTitle">购车支持</p>
                <div class="support-menutitle">
                  <span class="support-text">让您的购车体验更舒适</span>
                </div>
              </div>
              <span class="line-vertical"></span>
              <ul>
                <li>
                  <a @click="toggleTestDrive" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_07');">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/GouCheZhiChi/yysj.png">
                      <img  class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/头部导航切图/预约试驾.jpg">
                    </div>
                    <span>预约试驾</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
                <li>
                  <a href="http://www.geely.com/carbuysupport/dealerqueryamap" target="" style="" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_08');">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/GouCheZhiChi/jxscx.png">
                      <img class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/头部导航切图/经销商查询.jpg">
                    </div>
                    <span>经销商查询</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
                <li>
                  <a href="http://www.geely.com/carbuysupport/activecenter" target="" style="">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/GouCheZhiChi/schd.png">
                      <img class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/头部导航切图/市场活动.jpg">
                    </div>
                    <span>市场活动</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
                <li>
                  <a href="https://geely.tmall.com" target="_blank" style="" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_11');">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/GouCheZhiChi/tmqjd.png">
                      <img class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/头部导航切图/天猫旗舰店.jpg">
                    </div>
                    <span>天猫旗舰店</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
                <li>
                  <a href="http://www.geely.com/carservice" target="" style="" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_12')">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/CheZhuFuWu/GAKT.png">
                      <img class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/头部导航切图/车主服务.jpg">
                    </div>
                    <span>车主服务</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
                <li>
                  <a href="http://usedcar.geely.com/" target="_blank" style="">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/CheZhuFuWu/2.png">
                      <img class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/ershouche.jpg">
                    </div>
                    <span>二手车服务</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </li>
        <li>
          <router-link to="/">官方商城</router-link>
        </li>

        <li class="biz-cooperation">
          <a @click="toggleMenu('showSwhz')" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_22')">
            <span>商务合作</span>
            <i class="glfico-down"></i>
          </a>
          <div class="glmenu-content" :class="{'showSwhz': menuToggle.showSwhz}">
            <div class="glmenu-content-title">
              <span>商务合作</span>
              <i class="close" @click="toggleMenu('showSwhz')">×</i>
            </div>
            <div class="glmenu-content-body">
              <div class="content-left">
                <p class="menuTitle">商务合作</p>
                <div class="support-menutitle">
                  <span class="support-text">让您的购车体验更舒适</span>
                </div>
              </div>
              <span class="line-vertical"></span>
              <ul>
                <li>
                  <a href="http://visit.geely.com/home/order" target="_blank" style="" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_23')">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/ShangWuHeZuo/YJYYY.png">
                      <img class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/头部导航切图/吉利研发中心预约.jpg">
                    </div>
                    <span>吉利研发中心预约</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
                <li>
                  <a href="http://www.geely.com/joinus/merchantsjoining/GeelyCarJoin" target="" style="" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_24')">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/ShangWuHeZuo/QCZSJM.png">
                      <img class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/头部导航切图/吉利汽车招商.jpg">
                    </div>
                    <span>吉利汽车招商加盟</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
                <li>
                  <a href="http://promotion.geely.com/xny/joinus.html" target="_blank" style="" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_25')">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/ShangWuHeZuo/XNYJM.png">
                      <img class="pcs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/ImageSource/头部导航切图/吉利新能源招商加盟.jpg">
                    </div>
                    <span>吉利新能源招商加盟</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </li>
        <!-- <li>
          <a v-bind:href="clubHome" target="_blank" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_26')">吉行天下</a>
        </li> -->
        <li class="buy-support">
          <a @click="toggleMenu('showGfinal')" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_06')">
            <span>吉行天下</span>
            <i class="glfico-down"></i>
          </a>
          <div class="glmenu-content" :class="{'showGfinal': menuToggle.showGfinal}">
            <div class="glmenu-content-title">
              <span>购车支持</span>
              <i class="close" @click="toggleMenu('showGfinal')">×</i>
            </div>
            <div class="glmenu-content-body">
              <div class="content-left">
                <p class="menuTitle">购车支持</p>
                <div class="support-menutitle">
                  <span class="support-text">愿我们长久陪伴</span>
                </div>
              </div>
              <span class="line-vertical"></span>
              <ul>
                <li>
                  <a href="https://club.geely.com/" @click="toggleTestDrive" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_07');">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30clubimages.geely.com/resources/static/head/images/icon/jxtx-index.png">
                      <img  class="pcs"
                           src="https://dm30clubimages.geely.com/resources/bbs/static/clubNavImage/club_home.jpg">
                    </div>
                    <span>吉行天下首页</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
                <li>
                  <a href="https://club.geely.com/circle/circleHome" target="" style="" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_08'); ">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/GouCheZhiChi/jxscx.png">
                      <img class="pcs"
                           src="https://dm30clubimages.geely.com/resources/bbs/static/clubNavImage/club_quanzi.jpg">
                    </div>
                    <span>圈子</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
                <li>
                  <a href="https://club.geely.com/activity/activityHome" target="" style="">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/GouCheZhiChi/schd.png">
                      <img class="pcs"
                           src="https://dm30clubimages.geely.com/resources/bbs/static/clubNavImage/club_activity.jpg">
                    </div>
                    <span>活动</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
                <li>
                  <a href="https://club.geely.com/youjuhui/youjuhuiHome" target="" style="" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_11');">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/GouCheZhiChi/tmqjd.png">
                      <img class="pcs"
                           src="https://dm30clubimages.geely.com/resources/bbs/static/clubNavImage/club_youjuhui.jpg">
                    </div>
                    <span>友聚会</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
                <li>
                  <a href="https://club.geely.com/jishe/jisheHome" target="" style="" onclick="window.SCBeacon.trackGoal('G_HOME_HEADER_12')">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/CheZhuFuWu/GAKT.png">
                      <img class="pcs"
                           src="https://dm30clubimages.geely.com/resources/bbs/static/clubNavImage/club_jishe.jpg">
                    </div>
                    <span>吉行驿站</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
                <li>
                  <a href="https://club.geely.com/mall/list" target="" style="">
                    <div class="img">
                      <img class="phs"
                           src="https://dm30webimages.geely.com/GeelyOfficial/Files/Common/Top/CheZhuFuWu/2.png">
                      <img class="pcs"
                           src="https://dm30clubimages.geely.com/resources/bbs/static/clubNavImage/club_mall.jpg">
                    </div>
                    <span>吉币商城</span>
                    <span class="glfico-right"></span>
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </li>
      </ul>

      <div class="page-tools" v-if="$store.state.loginchange.loginChange === false">
        <span><router-link to="/login/registerorsginIn?stepId=sign">登录</router-link></span>
        <span><router-link to="/login/registerorsginIn?stepId=register">注册</router-link></span>
      </div>
      <div class="page-tools" v-if="$store.state.loginchange.loginChange === true">
        <span><a @click="goPersonInfo">我的</a></span>
        <span @click="signOut">退出</span>
      </div>

      <div class="mobile-tools">
        <p class="head">
          <i class="glfico-userhome"></i>
          <span class="ctrl"></span>
        </p>
        <div>
          <a data-href="advanceSearch.html">
            <i class="glfico-search"></i>
            <span>高级查询</span>
          </a>
          <a data-href="http://global.geely.com/" data-target="_blank">
            <i class="glfico-net"></i>
            <span>EN</span>
          </a>
          <a data-href="activityCenter.html">
            <i class="glfico-gift"></i>
            <span>活动中心</span>
          </a>
          <a data-href="pinpaiTianDi.html">
            <i class="glfico-wechat"></i>
            <span>品牌天地</span>
          </a>
          <a data-href="newsInformation.html">
            <i class="glfico-aclock"></i>
            <span>新闻资讯</span>
          </a>
          <a data-href="cheZhuService.html">
            <i class="glfico-calculator"></i>
            <span>车主服务</span>
          </a>
          <a data-href="http://mall.geely.com/" target="_blank">
            <i class="glfico-cart"></i>
            <span>商城</span>
          </a>
          <a v-bind:href="clubHome" target="_blank">
            <i class="glfico-aclock"></i>
            <span>俱乐部</span>
          </a>
        </div>
      </div>
    </header>

    <transition v-if="menuToggle.showCxzl || menuToggle.showPptd || menuToggle.showGczc || menuToggle.showSwhz" name="fade">
      <div class="mask"></div>
    </transition>
  </div>
</template>

<script>
import api from "./../../util/api";
import menuclickout from "./../../directives/menuClickOut";
import ElementUI from "element-ui";
import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

export default {
  name: "HeadMenu",
  data() {
    return {
      mask: false,
      searchParam: {
        pageNo: 1,
        pageSize: 100,
        beginPrice: 30000,
        endPrice: 300000
      },
      price: [30000, 300000],
      attriStructureList: [],
      structureCheck: false,
      checkedStructureModel: [],
      groupList: [],
      groupCheck: false,
      checkedGroup: [],
      dataList: [],
      keyword: "",
      selectCar: "",
      noregister: false,
      clubHome: "",
      menuToggle: {
        showCxzl: false,
        showPptd: false,
        showGczc: false,
        showCzfw: false,
        showSwhz: false,
        showGfinal: false
      },
      menuKeyFlag: false,
      options: [
        {
          value: "1",
          label: "车型1"
        },
        {
          value: "2",
          label: "车型2"
        },
        {
          value: "3",
          label: "车型3"
        },
        {
          value: "4",
          label: "车型4"
        },
        {
          value: "5",
          label: "车型5"
        }
      ]
    };
  },
  directives: { menuclickout },
  mounted() {
    this.clubHome = this.CLUB_ROOT + "?apiKey=" + localStorage.getItem("apiKey");
  },
  created() {
	  // this.init()
  },
  methods: {
	  init() {
		// let apiKey = localStorage.getItem('apiKey');
		// const apiKeyDate = Number(window.localStorage.getItem('apiKeyDate'));
		// const currentDate = new Date().getTime();
		// const utc = currentDate - apiKeyDate;
		// const day = utc / (24 * 60 * 60 * 1000);
		// if (apiKey) {
		// this.noregister = day < 1;
		// } else {
		// this.noregister = false;
		// }
		// if (this.noregister && !this.$store.state.loginchange.loginChange) {
		// this.$store.dispatch('loginChange');
		// }
		this.$store.dispatch('loginChange');
		this.onSearch(1);
	  },
    toggleTestDrive() {
        this.$store.dispatch('toggleTestDrive');
    },
    checkedStructureAll() {
      if (this.structureCheck) {
        this.checkedStructureModel = [];
      } else {
        this.checkedStructureModel = [];
        this.attriStructureList.map(item => {
          this.checkedStructureModel.push(item);
        });
      }
      this.onSearch();
    },
    checkedGroupAll() {
      if (this.groupCheck) {
        this.checkedGroup = [];
      } else {
        this.checkedGroup = [];
        this.groupList.map(item => {
          this.checkedGroup.push(item);
        });
      }
      setTimeout(() => {
		  this.onSearch();
	  },100)
    },
    onSearch(flag) {
      let that = this;
      this.code = 1;
      this.globalDate = Date.parse(new Date());
      this.searchParam.volumnList = this.checkBoxVolumnModel;
      this.searchParam.changeBoxList = this.checkedChangeBoxModel;
      this.searchParam.driverFilterList = this.checkedDriverModel;
      this.searchParam.seatFilterList = this.checkedSeatModel;
	  this.searchParam.structureFilterList = this.checkedStructureModel;
		this.searchParam.groupName = this.checkedGroup;
		if(this.groupCheck) {
			this.searchParam.groupName = []
		}
      this.searchParam.flag = null;
      if (flag === 1) {
        this.searchParam.flag = 1;
      }
      api.product
        .fetchDataList(this.searchParam)
        .then(response => {
          this.brLists = [];
          this.brLists = response.data.data.productData.data.filter(
            item => item.groupName === "博瑞"
          );
          this.byLists = [];
          this.byLists = response.data.data.productData.data.filter(
            item => item.groupName === "博越"
          );
          this.dhLists = [];
          this.dhLists = response.data.data.productData.data.filter(
            item => item.groupName === "帝豪"
          );
          this.yjLists = [];
          this.yjLists = response.data.data.productData.data.filter(
            item => item.groupName === "远景"
          );
          this.jgLists = [];
          this.jgLists = response.data.data.productData.data.filter(
            item => item.groupName === "金刚"
          );
          that.dataList = response.data.data.productData.data;
          that.totalCount = response.data.data.productData.totalCount;
          if (flag === 1) {
            that.volumnList = response.data.data.volumeInfoList;
            that.attriChangeBoxList = response.data.data.gearbox;
            that.attriDriverChangeBoxList = response.data.data.powerInfo;
            that.attriSeatList = response.data.data.seatInfo;
            that.attriStructureList = [];
            that.attriStructureList = response.data.data.structure;
            that.groupList = [];
            that.groupList = response.data.data.groupList;
            this.onSearch();
          }
          that.code = 0;
        })
        .catch(() => {
          console.log("网络异常");
          that.code = 0;
        });
    },
    changePrice() {
      if (this.price.length > 0) {
        this.searchParam.beginPrice = this.price[0];
        this.searchParam.endPrice = this.price[1];
        this.onSearch();
      }
    },
    toggleMenu(menuKey) {
      for (let key in this.menuToggle) {
        if (key !== menuKey) {
          this.menuToggle[key] = false;
        } else {
          this.menuToggle[key] = !this.menuToggle[key];
        }
      }
      if(this.menuToggle.showCxzl || this.menuToggle.showPptd || this.menuToggle.showGczc || this.menuToggle.showSwhz || this.menuToggle.showGfinal) {
        window.document.getElementsByTagName('html').item(0).className = 'noscroll';
      } else {
        window.document.getElementsByTagName('html').item(0).className = '';
      }
    },
    timer() {},
    search() {
      this.$router.push({ name: "Search", params: { keyword: this.keyword } });
    },
    goPersonInfo() {
      let apiKey = localStorage.getItem('apiKey');
      const apiKeyDate = Number(window.localStorage.getItem('apiKeyDate'));
      const currentDate = new Date().getTime();
      const utc = currentDate - apiKeyDate;
      const day = utc / (24 * 60 * 60 * 1000);
      if (apiKey && day < 1) {
        this.$router.push('/personInfo');
      } else {
        this.$store.dispatch("removeMember");
        window.localStorage.removeItem("apiKey");
        window.localStorage.removeItem("apiKeyDate");
        this.$store.dispatch("loginChange");
        this.noregister = false;
        this.$router.push("/");
      }
    },
    signOut() {
      this.$alert("确定要退出登录吗？", {
        confirmButtonText: "确定",
        callback: action => {
          if (action === "confirm") {
            let params = {};
            api
              .logout(params)
              .then(response => {
                if (response.data.code === "success") {
                  window.Countly.q.push(['add_event', {
                    key: '用户登出',
                    count: 1
                  }]);
                  this.$store.dispatch("removeMember");
                  localStorage.removeItem("apiKey");
                  localStorage.removeItem("apiKeyDate");
                  this.$store.dispatch("loginChange");
                  this.noregister = false;
                  this.$router.push("/");
                } else {
                  this.$store.dispatch("removeMember");
                  localStorage.removeItem("apiKey");
                  localStorage.removeItem("apiKeyDate");
                  this.$store.dispatch("loginChange");
                  this.noregister = false;
                  this.$router.push("/login/registerorsginIn?stepId=sign");
                }
              })
              .catch(() => {
                console.log("网络异常");
              });
          }
        }
      });
    },
    //获取用户基本信息
    getUser() {
      if (!localStorage.getItem('apiKey')) return false;
      this.$store.dispatch('fetchUserInfo');
	},
	onJump(item) {
		console.log(item,123)
		this.toggleMenu('showCxzl')
		this.$router.push({
			path: '/order',
			query: { productId: item.productId, path: 'Orderview' }
		})
	}
  },
  computed: {
    loginChange() {
      return this.$store.state.loginchange.loginChange;
	},
	department() {
		return this.$store.state.department
	}
  },
  watch: {
    loginChange() {
      this.noregister = this.$store.state.loginchange.loginChange;
      this.clubHome = this.CLUB_ROOT + "?apiKey=" + localStorage.getItem("apiKey");
      this.getUser();
	},
	department() {
		this.init()
	}
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let apiKey = vm.$route.query.apiKey;
      if(apiKey) {
        var params = {apiKey: apiKey};
        api.getClubUserInfo(params).then(response => {
          if (response.data.code === 'success') {
            localStorage.setItem("apiKey",response.data.data);
          }
        }).catch(() => {
          console.log("网络异常");
        });
      }
    });
  }
};
</script>
<style lang="stylus">
#header-ds {
  .el-select {
    width: 1.4rem;
  }

  .el-input__inner {
    height: 34px;
    padding-left: 10px;
    padding-right: 5px;
    background-color: #ededed;
    border-color: #ededed;
    border: 0px;
    border-radius: 0;
  }

  .el-input__suffix {
    right: 0.3rem;
  }

  &:focus {
    border-color: #ededed;
  }

  .el-icon-arrow-up:before {
    content: '';
  }

  .el-select__caret {
    border-width: 0.05rem;
    border-color: transparent transparent #888 transparent;
    border-style: solid;
    height: 0;
    left: 50%;
    margin-left: 0.04rem;
    margin-top: 0.02rem;
    position: absolute;
    top: 38%;
    width: 0.1rem;
  }
  .el-icon-arrow-up.is-reverse {
    top: 30%;
  }
}
</style>
<style scoped lang="less">
@import "../../../static/glficofont/glfico.less";
@import "../../../static/css/header.less";
header {
  z-index: 101;
  a:hover {
    text-decoration: none;
  }
}
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 6;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
<style lang="less">
.el-slider__bar {
  background-color: #1d6fc4;
  height:10px;
}
.el-slider__button {
  border: 1px solid #666;
  margin-top:4px;
  width:20px;
  height:20px;
  position:relative;
  &:before{
    content:'';
    width:10px;
    height:10px;
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    display:inline-block;
    background-color:#666;
    border-radius:10px;
  }
}
.el-slider__runway{
  height:10px;
}

</style>




// WEBPACK FOOTER //
// src/components/common/HeadMenu.vue